import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ActivatedRoute } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrl: './add-city.component.scss'
})
export class AddCityComponent {
  cityForm: any = FormGroup;
  submitted = false;
  city_id = "0";
  buttonclick = false;
  selectedCountryName: any = '';

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService,
  ) {
    this.route.params.subscribe((params: any) => {
      this.city_id = params['id'] || '0';
      if (this.city_id != "0")
        this.getCityById();
    });
    this.cityForm = this.fb.group({
      city_id: Number(this.city_id),
      city_name: ['', [Validators.required]],
      country_name: ['', [Validators.required]],
      action: '',
    })

  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.cityForm.controls;
  }

  cityAdd() {
    this.submitted = true;
    if (this.cityForm.valid) {
      let data = {
        city_id: Number(this.city_id),
        city_name: this.cityForm.value.city_name,
        country_name: this.cityForm.value.country_name,
        Action: this.city_id == "0" ? 'Insert' : 'Update',
      };

      if (this.cityForm.valid) {
        this.mainService.postApi(ApiUrls.addCity, data, 1).subscribe((res: any) => {
          if (res.status == 1) {
            this.toasterService.toastSuccess(res.response);
            this.goBackToPrevPage();
          } else
            this.toasterService.toastError(res.response);
        });
        this.cityForm.reset();
        this.submitted = false;
      } else {
        this.submitted = true
      }
    }
  }

  editCity(data: any) {
    this.buttonclick = true;
    this.selectedCountryName = data.country_name;
    this.cityForm.patchValue({
      city_id: data.city_id,
      city_name: data.city_name,
      country_name: data.country_name,
    });
    window.scroll({
      top: 0
    })
  }

  getCityById() {
    this.mainService.getApi(ApiUrls.cityListById + this.city_id).subscribe((res: any) => {
      this.editCity(res.city[0]);
    })
  }
}
